import React, { Component } from 'react';
import { Table, Divider, Button, Icon, Popconfirm, message} from 'antd';
import axios from 'axios';
import CountryDialogForm from './CountryForm';
import { connect } from 'react-redux';

const API_HOST_URL = process.env.REACT_APP_API_URL

class Country extends Component{
  
  state = {
    countries: [],
    country: {},
    visible: false,
    requestType: '',
    confirmLoading: false
  }

  componentDidMount(){
    this.fetchData();
  }

  columns = [
    {
      title: 'Country Name',
      dataIndex: 'countryName',
      key: 'countryName'
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <span>
        <a href="javascript:;" onClick={() => this.handleEdit(record)}><Icon type="edit" /></a>

        <Divider type="vertical" />

        {this.state.countries.length >= 1
          ? (
            <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)}>
              <a href="javascript:;"><Icon type="delete" /></a>
            </Popconfirm>
          ) : null}
          </span>
      ),

    }
  ];

  fetchData = () => {
    axios.get(`${API_HOST_URL}/api/systemsetup/country/`)
      .then(res => {
        this.setState({
          countries: res.data
        })
      })
  }

  handleCreate = () => {
    const form = this.formRef.props.form;
    const requestType = this.state.requestType;

    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      
      this.setState({ confirmLoading: true });

      switch( requestType ){
        case 'post':
            return axios.post(`${API_HOST_URL}/api/systemsetup/country/`, {
              countryName: values.countryName
            })
            .then(res => {
              console.log(res)
              form.resetFields();
              this.setState({ visible: false, confirmLoading: false});
              this.fetchData()
              message.success('Country added successfully!');
        })
            .catch(error => {
                // console.err(error)
                message.error('Not saved! a problem occured. '+error, 10);
            });

        case 'put':
            return axios.put(`${API_HOST_URL}/api/systemsetup/country/${this.state.country.id}/`, {
              countryName: values.countryName
            })
                .then(res => {
                  console.log(res)
                  form.resetFields();
                  this.setState({ visible: false, confirmLoading: false });
                  this.fetchData()
            })
                .catch(error => {
                  // console.err(error)
                  message.error('Not saved! a problem occured. '+error, 10);
                });
                
        default: return;
      }
    });
  }

  handleEdit = record => {
      this.setState({country: record});
      this.showModal('put');
  }

  handleDelete = (record) => {
    const countries = [...this.state.countries];

    return axios.delete(`${API_HOST_URL}/api/systemsetup/country/${record.id}/`)
                .then(res => {
                  console.log(res)

                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => {
                  message.error('Cant delete! a problem occured. '+error, 10);
                });
  }

  showModal = (type) => {
    if( type === 'post'){
      //no data should be passed to dialog form
      this.setState({country: {}});
    }

    this.setState({ visible: true, requestType: type });
  }

  handleCancel = () => {
    this.setState({ visible: false, confirmLoading: false });
  }

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }

    render(){
        return(
          <div>
            {
              this.props.userPermissions.indexOf('add_country') > -1 ? 
            <Button type="primary" onClick={() => this.showModal('post')}>Add Country</Button>
            : ''
            }
            {
              this.props.userPermissions.indexOf('view_country') > -1 ?
              <Table columns={this.columns} dataSource={this.state.countries} rowKey="id"/>
              : 'You do not have rights to view countries. Please Contact your Administrator'
            }
            

            <CountryDialogForm
              wrappedComponentRef={this.saveFormRef}
              visible={this.state.visible}
              onCancel={this.handleCancel}
              onCreate={this.handleCreate}
              data={this.state.country}
              confirmLoading={this.state.confirmLoading}/>
        </div>
        );
    }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    userPermissions: state.userPermissions
  }
}

export default connect(mapStateToProps, null)(Country);
// export default Country;
